import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface PermissionRule {
	action: string;
	subject: string;
	inverted?: boolean;
}

export const useGetPermissions = (options: { enabled?: boolean } = {}) => {
	return useQuery({
		queryKey: ['permissions'],
		enabled: options.enabled,
		queryFn: async () => {
			const { data } = await api.get<{ permissions: PermissionRule[] }>('/user/getPermissions');
			return data.permissions;
		},
	});
};
